export const isLocalEnvironment = () =>
  process.env.NEXT_PUBLIC_ENV === 'localhost';
